import { render, staticRenderFns } from "./VAuthentication.vue?vue&type=template&id=2e6583f4"
import script from "./VAuthentication.vue?vue&type=script&lang=ts"
export * from "./VAuthentication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports